"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cascader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Popup = require("../Popup");
var _Message = require("../Message");
var _ButtonGroup = require("../ButtonGroup");
var Cascader = function Cascader(props) {
  var className = props.className,
    content = props.content,
    buttonGroup = props.buttonGroup,
    popupProps = props.popupProps;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('cascader'), className)
  }, /*#__PURE__*/_react.default.createElement(_Message.Message, {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('cascader-message'), className),
    content: content,
    buttonGroup: buttonGroup
  }), /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    showCloseIcon: true,
    active: popupProps.show,
    title: popupProps.title,
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('modal-cascader'), className),
    contentClassName: (0, _getPrefixCls.getPrefixCls)('modal-cascader-content'),
    onClose: popupProps.onClose
  }, /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, (0, _extends2.default)({
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('modal-cascader-content-buttons'), className)
  }, popupProps))));
};
exports.Cascader = Cascader;